exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".activate[data-v-800de8dc]{position:absolute;width:100%;height:100%;top:0}img[data-v-800de8dc]{position:absolute;width:60px;top:49%;left:9%}img[data-v-800de8dc]:nth-child(2){top:69%;left:25%}img[data-v-800de8dc]:nth-child(3){top:31%;left:30%}img[data-v-800de8dc]:nth-child(4){top:51%;left:32%}img[data-v-800de8dc]:nth-child(5){top:49%;left:50%}@media only screen and (max-width:750px){img[data-v-800de8dc]{position:absolute;width:40px;top:56%;left:15%}img[data-v-800de8dc]:nth-child(2){top:86%;left:26%}img[data-v-800de8dc]:nth-child(3){top:40%;left:27%}img[data-v-800de8dc]:nth-child(4){top:61%;left:36%}img[data-v-800de8dc]:nth-child(5){top:60%;left:53%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-800de8dc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/containers/section1/pages/components/Animate.vue
// module id = 69
// module chunks = 0